import styled from 'styled-components';
import { Button } from '@vds/buttons';

import ModalButton from './modalButton';

import { isMobile } from '../../../../../common/Helpers';

const isMobileDevice = isMobile();

export const StyledButtonWrapper = styled(Button)`
  @media (max-width: 430px) {
    width: 100% !important;
    marginbottom: 50px;
  }
`;

export const ModalButtonContainer = styled.div`
  width: ${isMobileDevice ? '100%' : ''};
  padding-right: ${isMobileDevice ? '30px' : ''};
  @media (min-height: 650px) {
    position: ${isMobileDevice ? 'fixed' : ''};
    bottom: ${isMobileDevice ? '0' : ''};
    padding-right: ${isMobileDevice ? '30px' : ''};
  }
  @media (max-height: 649px) {
    position: ${isMobileDevice ? 'absolute' : ''};
    padding-top: ${isMobileDevice ? '24px' : ''};
  }
`;

export const ButtonWrapper = styled(ModalButton)`
  width: 100%;
  height: 44px;
  background-color: transparent;

  background-color: ${(props) => (props.isDisabled ? 'transparent' : 'black')};
  color: ${(props) => (props.isDisabled ? '#d8dada' : 'white')};
  /* border-color: #d8dada; */
  @media (min-width: 415px) {
    width: 183px;
  }
`;
